import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right-1_mJc",
  "use": "right-1_mJc-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"right-1_mJc\"><path d=\"M14 6.979L6.951 0 5.323 1.639l4.173 4.202H0v2.318h9.496l-4.173 4.202L6.951 14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol